<template>
    <PopupRouterView :showLeftIcon="true" label="Work Order Execution Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="workorderexecution"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="workOrderExecutionInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<p class="scannerText">Hi, {{ currentUser }}</p>
						<b-row>
							<b-col cols="12" class="flex-item center-item">
								<b-avatar class="user-avatar" size="6rem"></b-avatar>
							</b-col>
						</b-row>
						<p class="scannerText">{{ greeting }}</p>
						<b-row class="shift-row" v-for="(shift, index) in shifts" :key="index">
							<b-col cols="6" class="flex-item start-item">
								<p class="shift-title mb-2">{{ shift.name }}</p>
							</b-col>
							<b-col cols="6" class="flex-item end-item">
								<b-button class="mb-2" variant="outline-success" @click="goToNext(2, shift.id)">Select ></b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-work-order-process-detail" ref="fieldset-work-order-process-detail" :model.sync="workOrderProcessDetailQrCode" label="Work Order Process Number" @scannedMethod="scanWorkOrderProcessDetail" :isBusy="isScanWorkOrderProcessDetailLoading" autofocus />
						<app-input-scan :disabled="!isWopScanned" id="fieldset-bill-of-process-detail" ref="fieldset-bill-of-process-detail" :model.sync="billOfProcessDetailQrCode" label="Work Order Sub Process" @scannedMethod="scanBillOfProcessDetail" :isBusy="isScanBillOfProcessDetailLoading"/>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Work Order Sub Process" :model="model.billOfProcessDetail != null ? model.billOfProcessDetail.subProcessNumber : null"  />
						<app-label label-cols-lg="12" size="md" label="WOP Number" :model="(model.workOrderProcessDetail != null) ? model.workOrderProcessDetail.workOrderProcess != null ? model.workOrderProcessDetail.workOrderProcess.workOrderProcessNumber: null : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Part Number" :model="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.part != null ? model.workOrderProcessDetail.part.partNumber : null : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Qty" :model="(model.workOrderProcessDetail != null) ? model.workOrderProcessDetail.qtyPlan : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Customer" :model="(customer != null) ? customer.name : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Line" :model="(line != null) ? line.code : null"></app-label>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 4">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-machine" ref="fieldset-machine" :model.sync="machineQrCode" label="Machine" @scannedMethod="scanMachine" :isBusy="isScanMachineLoading" autofocus />
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 5">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-operator" ref="fieldset-operator" :model.sync="operatorQrCode" label="Operator" @scannedMethod="scanOperator" :isBusy="isScanOperatorLoading" autofocus />
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 6">
				<b-row>
					<b-col cols="12">
						<p class="scannerText">{{ operatorFullName }}</p>
						<b-row>
							<b-col cols="12" class="flex-item center-item">
								<b-avatar class="user-avatar" size="6rem"></b-avatar>
							</b-col>
						</b-row>
						<p class="scannerText">{{ greeting }}</p>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="md" label="Line" :model="model.machine != null ? model.machine.name : null"></app-label>
						<app-label label-cols-lg="12" size="sm" label="Work Order Sub Process" :model="model.billOfProcessDetail != null ? model.billOfProcessDetail.subProcessNumber : null"  />
						<app-label label-cols-lg="12" size="md" label="WOP Number" :model="(model.workOrderProcessDetail != null) ? model.workOrderProcessDetail.workOrderProcess != null ? model.workOrderProcessDetail.workOrderProcess.workOrderProcessNumber: null : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Part Number" :model="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.part != null ? model.workOrderProcessDetail.part.partNumber : null : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Qty" :model="(model.workOrderProcessDetail != null) ? model.workOrderProcessDetail.qtyPlan : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Customer" :model="(customer != null) ? customer.name : null"></app-label>
						<app-label label-cols-lg="12" size="md" label="Line" :model="(line != null) ? line.code : null"></app-label>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 7">
				<b-row>
					<b-col cols="12">
						<p class="scannerText bold">Everything is ready...</p>
						<b-row>
							<b-col cols="12" class="flex-item center-item">
								<b-img :src="`${publicPath}/img/no-data.png`" class="image-placeholder"></b-img>
							</b-col>
						</b-row>
						<p class="scannerText">Let's Start!</p>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12" class="flex-item center-item">
						<b-button class="btn big-btn" @click="startProduction"> <b-icon icon="cursor-fill"></b-icon> Start</b-button>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 8">
				<b-row>
					<b-col cols="12">
						<p class="scannerText bold big-text">{{ this.formattedTime }}</p>
						<b-row>
							<b-col cols="12" class="flex-item center-item">
								<b-img :src="`${publicPath}/img/no-data.png`" class="image-placeholder"></b-img>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12" class="flex-item center-item">
						<b-button class="btn big-btn" @click="finishProduction"> <b-icon icon="flag-fill"></b-icon> Finish</b-button>
					</b-col>
				</b-row>
			</span>

			<span v-if="scanPageIndex == 9">
				<div class="fixed-header">
					<b-row>
						<b-col cols="12">
							<p class="scannerText bold">To-Do List</p>
						</b-col>
					</b-row>
					<b-row>
						<b-col class="production-time" cols="6">
							<p class="blue-text">Start Production</p>
							<p>{{ formatDate(model.startProduction) }}</p>	
						</b-col>
						<b-col class="production-time" cols="6">
							<p class="blue-text">Finish Production</p>
							<p>{{ formatDate(model.finishProduction) }}</p>	
						</b-col>
					</b-row>
				</div>
				<div class="space-content">&nbsp;</div>
				<div>
					<app-table-input-custom 
						title = "Hold Time"
						:bordered="true" :items="workOrderExecutionHoldTimes" 
						:fields="fieldsWorkOrderExecutionHoldTime" 
						:busy="isDataLoading" 
						:sort-by.sync="sortByWorkOrderExecutionHoldTime" 
						:sort-desc.sync="sortDescWorkOrderExecutionHoldTime" small responsive
						@deleteButtonMethod="deleteRowDataWorkOrderExecutionHoldTime"	
						@showPopupAddMethod="addDataWorkOrderExecutionHoldTime"	
						:showActionButton="true"
						:showDeleteButton="true"
						:showAddButton="true"
						:showAddFromClipboardButton="false"	
						:showReplaceFromClipboardButton="false"	
						:showUploadButton="false"	
						:showDownloadButton="false">						
							
						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + ( workOrderExecutionHoldTimePageSize * (currentWorkOrderExecutionHoldTimePage - 1))) }}
						</template>
											
						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>
											
						<template v-slot:cell(startTime)="row">
							<!-- <app-label label-cols-lg="12" size="md" label="Start Time" :model="row.item.ngCategory != null ? row.item.ngCategory.name : ''" :nolabel="true" /> -->
							<!-- <new-date-time-picker label-cols-lg="1" :model="row.item.startTime" @update:model="(newValue) => updateStartTime(newValue, row.item)" /> -->
							{{ row.item.startTime | moment('DD-MMM-YYYY HH:mm') }}
						</template>
						<template v-slot:cell(endTime)="row">
							<!-- <app-label label-cols-lg="12" size="md" label="Ng Qty" :model="row.item.ngQty" :nolabel="true" /> -->
							{{ row.item.endTime | moment('DD-MMM-YYYY HH:mm') }}
						</template>
					</app-table-input-custom>
					
					<WorkOrderExecutionHoldTimeScan
						:model="modelWorkOrderExecutionHoldTime"
						:modelId="workOrderExecutionHoldTimeId"
						:woeId="model.id"
						:openPopup="isShowPopupWorkOrderExecutionHoldTime"
						@resetMethod="resetModal"
						@addButtonMethod="addRowDataWorkOrderExecutionHoldTime"/>
				</div>
				<div class="space-content">&nbsp;</div>	
				<div v-for="(group, category) in groupedControlTimes" :key="category">
					<br>
					<span class="bold">{{ category }}</span>
					<b-row v-for="(controlTime, index) in group" :key="index" class="to-do-list">
						<b-col cols="12" class="flex-item start-item control-time-title">
							<p class="blue-text">{{ controlTime.productionControlTime != null ? controlTime.productionControlTime.standarTimeIdStandarTimeName : "" }}</p>
						</b-col>
						<!-- <b-col cols="12" md="6">
							<app-input-datetimepicker-custom :min="model.startProduction" :max="model.finishProduction" :id="'fieldset-start-control-time-' + index" label-cols-lg="4" label="From" size="sm" :model.sync="controlTime.startControlTime" :date-format-options="{year: 'numeric', month: '2-digit', day: '2-digit'}" locale="en-GB" @change="updateDataControlTime(controlTime.id, controlTime)" />
						</b-col>
						<b-col cols="12" md="6">
							<app-input-datetimepicker-custom :min="model.startProduction" :max="model.finishProduction" :id="'fieldset-stop-control-time-' + index" label-cols-lg="4" label="To" size="sm" :model.sync="controlTime.stopControlTime" :date-format-options="{year: 'numeric', month: '2-digit', day: '2-digit'}" locale="en-GB" @change="updateDataControlTime(controlTime.id, controlTime)" />
						</b-col> -->

						<b-col cols="12">
							<app-input-textbox id="fieldset-duration" label-cols-lg="6"  label="Duration" label-for="input-duration" size="sm" :model.sync="controlTime.duration"  @change="updateDataControlTime(controlTime.id, controlTime)" />
						</b-col>

					</b-row>
					
					<!-- <app-table-input-custom 
						:title = "category"
						:bordered="true" :items="group" 
						:fields="fieldsInputControlTime" 
						:busy="isDataLoading" 
						small responsive
						:showActionButton="false"
						:showDeleteButton="false"
						:showAddButton="false"
						:showAddFromClipboardButton="false"	
						:showReplaceFromClipboardButton="false"	
						:showUploadButton="false"	
						:showDownloadButton="false">						
							
						<template v-slot:cell(no)="row">
							{{ row.index + 1 }}
						</template>
											
						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>
											
						<template v-slot:cell(controlTime)="row">
							<b-row class="to-do-list">
								<b-col cols="12" class="flex-item start-item control-time-title">
									<p class="blue-text">{{ row.item.productionControlTime != null ? row.item.productionControlTime.standarTimeIdStandarTimeName : "" }}</p>
								</b-col>
								<b-col cols="12" md="6">
									<app-input-datetimepicker class="text-small" :min="model.startProduction" :max="model.finishProduction" :id="'fieldset-start-control-time-' + index" label-cols-lg="4" label="From" :model.sync="row.item.startControlTime" :date-format-options="{year: 'numeric', month: '2-digit', day: '2-digit'}" locale="en-GB" @change="updateDataControlTime(row.item.id, row.item)" />
								</b-col>
								<b-col cols="12" md="6">
									<app-input-datetimepicker-custom class="text-small" :min="model.startProduction" :max="model.finishProduction" :id="'fieldset-stop-control-time-' + index" label-cols-lg="4" label="To" :model.sync="row.item.stopControlTime" :date-format-options="{year: 'numeric', month: '2-digit', day: '2-digit'}" locale="en-GB" @change="updateDataControlTime(row.item.id, row.item)" />
								</b-col>
							</b-row>
						</template>

					</app-table-input-custom> -->

					
				</div>
				
			</span>
			<span v-if="scanPageIndex == 10">
				<b-card no-body>
					<b-tabs card>
						<b-tab title="Result 1" v-if="model.workOrderExecutionDetail.length > 0" active>
							<b-card-text class="bg-white">
								<app-label label-cols-lg="12" size="md" label="Part No" :model="model.workOrderExecutionDetail[0].part != null ? model.workOrderExecutionDetail[0].part.partNumber : null"></app-label>
								<app-label label-cols-lg="12" size="md" label="Part Name" :model="model.workOrderExecutionDetail[0].part != null ? model.workOrderExecutionDetail[0].part.partName : null"></app-label>
								<app-label label-cols-lb="12" size="md" label="Qty Plan" :model="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.qtyPlan : 0" />
								<app-input-textbox :id="'input-good-qty'" label-cols-lg="12" label="Good Qty" size="sm" :model.sync="model.workOrderExecutionDetail[0].goodQty"   @change="updateDataWorkOrderDetail(model.workOrderExecutionDetail[0], model.workOrderExecutionDetail[0].id)" type="number"/>
								<app-input-textbox v-if="isLastProcess" :id="'input-pending-qty'" label-cols-lg="12" label="Pending Qty" size="sm" :model.sync="model.workOrderExecutionDetail[0].pendingQty"   @change="updateDataWorkOrderDetail(model.workOrderExecutionDetail[0], model.workOrderExecutionDetail[0].id)"  type="number"/>

								<app-table-input-custom 
									title = "Ng Qty"
									:bordered="true" :items="workOrderExecutionNgs1" 
									:fields="fieldsWorkOrderExecutionNg" 
									:busy="isDataLoading" 
									:sort-by.sync="sortByWorkOrderExecutionNg" 
									:sort-desc.sync="sortDescWorkOrderExecutionNg" small responsive
									@deleteButtonMethod="deleteRowDataWorkOrderExecutionNg1"	
									@showPopupAddMethod="addDataWorkOrderExecutionNg1"	
									:showActionButton="true"
									:showDeleteButton="true"
									:showAddButton="true"
									:showAddFromClipboardButton="false"	
									:showReplaceFromClipboardButton="false"	
									:showUploadButton="false"	
									:showDownloadButton="false">						
										
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( workOrderExecutionNgPageSize1 * (currentWorkOrderExecutionNgPage1 - 1))) }}
									</template>
														
									<template v-slot:table-busys>
										<div class="text-center my-2">
											<b-spinner class="align-middle text-primary"></b-spinner>
											<strong class="ml-2">Loading...</strong>
										</div>
									</template>
														
									<template v-slot:cell(ngCategory)="row">
										<app-label label-cols-lg="12" size="md" label="Ng Category" :model="row.item.ngCategory != null ? row.item.ngCategory.name : ''" :nolabel="true" />
									</template>
									<template v-slot:cell(ngQty)="row">
										<!-- <app-label label-cols-lg="12" size="md" label="Ng Qty" :model="row.item.ngQty" :nolabel="true" /> -->
										<app-input-textbox :id="'input-ng1-qty-' + row.index" label-cols-lg="12" label="Ng Qty" size="sm" :model.sync="row.item.ngQty" @change="updateDataWorkOrderNg(row.item, row.item.id)" type="number"/>
									</template>
								</app-table-input-custom>

								<WorkOrderExecutionNgScan
									:model="modelWorkOrderExecutionNg1"
									:woedId="model.workOrderExecutionDetail[0].id"
									:modelId="workOrderExecutionNgId"
									:openPopup="isShowPopupWorkOrderExecutionNg1"
									@resetMethod="resetModal"
									@addButtonMethod="addRowDataWorkOrderExecutionNg"/>
							</b-card-text>
						</b-tab>
						<b-tab title="Result 2" v-if="model.workOrderExecutionDetail.length > 1">
							<b-card-text class="bg-white">
								<app-label label-cols-lg="12" size="md" label="Part No" :model="model.workOrderExecutionDetail[1].part != null ? model.workOrderExecutionDetail[1].part.partNumber : null"></app-label>
								<app-label label-cols-lg="12" size="md" label="Part Name" :model="model.workOrderExecutionDetail[1].part != null ? model.workOrderExecutionDetail[1].part.partName : null"></app-label>
								<app-label label-cols-lb="12" size="md" label="Qty Plan" :model="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.qtyPlan : 0" />
								<app-input-textbox :id="'input-good-qty'" label-cols-lg="12"  type="number" label="Good Qty" size="sm" :model.sync="model.workOrderExecutionDetail[1].goodQty"   @change="updateDataWorkOrderDetail(model.workOrderExecutionDetail[1], model.workOrderExecutionDetail[1].id)" />
								<app-input-textbox v-if="isLastProcess" :id="'input-pending-qty'" label-cols-lg="12" label="Pending Qty" size="sm" :model.sync="model.workOrderExecutionDetail[1].pendingQty"   @change="updateDataWorkOrderDetail(model.workOrderExecutionDetail[1], model.workOrderExecutionDetail[1].id)"  type="number" />

								<app-table-input-custom 
									title = "Ng Qty"
									:bordered="true" :items="workOrderExecutionNgs2" 
									:fields="fieldsWorkOrderExecutionNg" 
									:busy="isDataLoading" 
									:sort-by.sync="sortByWorkOrderExecutionNg" 
									:sort-desc.sync="sortDescWorkOrderExecutionNg" small responsive
									@deleteButtonMethod="deleteRowDataWorkOrderExecutionNg2"	
									@showPopupAddMethod="addDataWorkOrderExecutionNg2"	
									:showActionButton="true"
									:showDeleteButton="true"
									:showAddButton="true"
									:showAddFromClipboardButton="false"	
									:showReplaceFromClipboardButton="false"	
									:showUploadButton="false"	
									:showDownloadButton="false">						
										
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( workOrderExecutionNgPageSize2 * (currentWorkOrderExecutionNgPage2 - 1))) }}
									</template>
														
									<template v-slot:table-busys>
										<div class="text-center my-2">
											<b-spinner class="align-middle text-primary"></b-spinner>
											<strong class="ml-2">Loading...</strong>
										</div>
									</template>
														
									<template v-slot:cell(ngCategory)="row">
										<app-label label-cols-lg="12" size="md" label="Ng Category" :model="row.item.ngCategory != null ? row.item.ngCategory.name : ''" :nolabel="true" />
									</template>
									<template v-slot:cell(ngQty)="row">
										<!-- <app-label label-cols-lg="12" size="md" label="Ng Qty" :model="row.item.ngQty" :nolabel="true" /> -->
										<app-input-textbox :id="'input-ng2-qty-' + row.index" label-cols-lg="12" label="Ng Qty" size="sm" :model.sync="row.item.ngQty" @change="updateDataWorkOrderNg(row.item, row.item.id)"  type="number"/>
									</template>
								</app-table-input-custom>

								<WorkOrderExecutionNgScan
									:model="modelWorkOrderExecutionNg2"
									:woedId="model.workOrderExecutionDetail[1].id"
									:modelId="workOrderExecutionNgId"
									:openPopup="isShowPopupWorkOrderExecutionNg2"
									@resetMethod="resetModal"
									@addButtonMethod="addRowDataWorkOrderExecutionNg"/>
							</b-card-text>
						</b-tab>
					</b-tabs>
				</b-card>

				<div>
					<p class="bold">Summary Qty</p>
					<!-- <b-row v-for="(item, key) in summaries" :key="key">
						<b-col md="3" lg="3" sm="6" class="summary-width">Part {{ item.partNumber }}</b-col>
						<b-col cols="2">: {{ item.qty }}</b-col>
					</b-row> -->
					<table>
						<tr v-for="(item, key) in summaries" :key="key">
							<td>Part {{ item.partNumber }}</td>
							<td>:</td>
							<td>{{ item.qty }}</td>
						</tr>
					</table>
				</div>
			</span>
			<span v-if="scanPageIndex == 11">
				<b-row>
					<b-col cols="12">
						<p class="scannerText bold">You have finished <br> your work</p>
						<b-row>
							<b-col cols="12" class="flex-item center-item">
								<b-img :src="`${publicPath}/img/no-data.png`" class="image-placeholder"></b-img>
							</b-col>
						</b-row>
						<p class="scannerText">Congratulations!</p>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12" class="flex-item center-item">
						<b-button class="btn btn-fill-success big-btn" @click="$router.back()">OK</b-button>
					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<span v-if="scanPageIndex == 1">&nbsp;</span>
			<b-button v-if="scanPageIndex != 1 && scanPageIndex != 7 && scanPageIndex != 8 && scanPageIndex != 9 && scanPageIndex != 10 && scanPageIndex != 11" size="sm" variant="outline-warning" class="float-left" @click="goToPrev(scanPageIndex - 1)">&lt; Previous</b-button>

			<b-button v-if="scanPageIndex == 3 || scanPageIndex == 9" size="sm" @click="goToNext(scanPageIndex + 1, 'screen 4')" variant="outline-success" class="float-left">Next ></b-button>
			<b-button v-if="scanPageIndex == 6" size="sm" @click="userConfirmation" variant="outline-success" class="float-left">Next ></b-button>
			<b-button v-if="scanPageIndex == 10" size="sm" variant="outline-success" class="float-right" @click="productionResult()">Finish</b-button>
        </template>
		<WorkOrderExecutionDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelWorkOrderExecutionDetail"
			:modelId="workOrderExecutionDetailId"
			:openPopup="isShowPopupWorkOrderExecutionDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataWorkOrderExecutionDetail"/>
		<WorkOrderExecutionControlTimeScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelWorkOrderExecutionControlTime"
			:modelId="workOrderExecutionControlTimeId"
			:openPopup="isShowPopupWorkOrderExecutionControlTime"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataWorkOrderExecutionControlTime"/>

    </PopupRouterView>
</template>
<style>
	p {
		margin: 0 !important
	}
	.to-do-list {
		margin: 15px 0;
	}
	.blue-text {
		color :rgb(52, 187, 228)
	}
	.input-label-detail {
		font-size: 25px !important;
		word-wrap: break-word;
		line-height: 1.3 !important;
	}
	.big-text {
		font-size: 40px !important;
	}
	.scannerText { 
		font-size: 24px;
		margin: 10px auto;
		display: block;
		text-align: center;
		color: black !important;
	}
	.flex-item {
		display: flex;
		align-items: center;
	}
	.start-item {
		justify-content: flex-start;
	}
	.center-item {
		justify-content: center;
	}
	.end-item {
		justify-content: flex-end;
	}
	.user-avatar, .shift-row {
		margin: 20px 0;
	}
	.shift-row {
		border-bottom: 1px solid rgb(94, 94, 94);
	}
	.shift-title {
		font-size: 20px;
		color: #626F9C;
	}
	.big-btn {
		font-size: 24px !important;
		font-weight: bold !important;
		background-color: #FFC978 !important;
		padding: 10px 100px !important;
	}
	.bold {
		font-weight: bold !important;
	}
	.control-time-title {
		font-size: 20px;
		margin: 10px 0;
	}
	.bg-white {
		background: white !important;
	}

	.input-scan-page .form-control {
		font-size: 16px !important;
	}
	
	.production-time {
		display: flex;
		flex-direction: column;
		align-items: center
	}

	.fixed-header {
		position: fixed;
		margin-top: -35px;
		max-width: 970px;
		width: 970px;
		padding: 0px;
		background-color: white; /* Ensure it has a background color */
		z-index: 1000; /* Adjust the z-index if necessary */
		/* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
		/*margin-left: -25px;*/
	}

	.space-content {
		margin-top: 80px;
	}

	@media (max-width: 500px){
		.summary-width {
		min-width: 50% !important;
		}

		.fixed-header {
		max-width: 390px !important;
		}
	};

	@media (max-width: 400px){
		.fixed-header {
		max-width: 330px !important;
		}
	};


</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import moment from 'moment';
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import WorkOrderExecutionHoldTime from '@/models/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTime';
import WorkOrderExecutionHoldTimeFilter from '@/filters/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTimeFilter';
import Shift from '@/models/Shift/Shift';
import ShiftFilter from '@/filters/Shift/ShiftFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import BillOfProcessDetail from '@/models/BillOfProcess/BillOfProcessDetail';
import BillOfProcessDetailFilter from '@/filters/BillOfProcess/BillOfProcessDetailFilter';
import AppLabel from '@/components/AppLabel';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepickerCustom from '@/components/AppInputDatetimepickerCustomHtml5';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputTextbox from '@/components/AppInputTextbox';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderExecutionDetail from '@/models/WorkOrderExecution/WorkOrderExecutionDetail';
import WorkOrderExecutionDetailFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionDetailFilter';
import WorkOrderExecutionControlTime from '@/models/WorkOrderExecution/WorkOrderExecutionControlTime';
import WorkOrderExecutionControlTimeFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionControlTimeFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import Customer from '@/models/Customer/Customer';
import Line from '@/models/Line/Line';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputCustom from '@/components/AppTableInputCustom'
import WorkOrderExecutionDetailScan from '@/views/WorkOrderExecution/WorkOrderExecutionDetailScan';
import WorkOrderExecutionNgScan from '@/views/WorkOrderExecution/WorkOrderExecutionNgScan';
import ProductionControlTimeDetail from '@/models/ProductionControlTime/ProductionControlTimeDetail';
import ProductionControlTimeDetailFilter from '@/filters/ProductionControlTime/ProductionControlTimeDetailFilter';
import WorkOrderExecutionControlTimeScan from '@/views/WorkOrderExecution/WorkOrderExecutionControlTimeScan';
import PopupRouterView from '@/components/PopupRouterView';
import WorkOrderExecutionNg from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNg';
import WorkOrderExecutionNgFilter from '@/filters/WorkOrderExecutionNg/WorkOrderExecutionNgFilter';
import { BIconArrowReturnLeft } from 'bootstrap-icons-vue';
import NewDateTimePicker from '@/components/AppInputDateTimePickerCustomPineda.vue';
import WorkOrderExecutionHoldTimeScan from '@/views/WorkOrderExecution/WorkOrderExecutionHoldTimeScan';
export default {
	components : {
		AppLabel,
		AppInputDatetimepicker,
		AppInputDatetimepickerCustom,
		AppInputTextbox,
		AppTableInputCustom,
		WorkOrderExecutionDetailScan,
		WorkOrderExecutionControlTimeScan,
		AppTableInput,
		PopupRouterView,
		AppInputScan,
		WorkOrderExecutionNgScan,
		NewDateTimePicker,
		WorkOrderExecutionHoldTimeScan
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsWorkOrderExecutionDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"workOrderProcessDetail": { "class" : "th-work-order-process-detail first-child", "label" : "Work Order Process Detail Id", key: 'workOrderProcessDetail.part', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part.partNumber', sortable: false}}, 
				{"goodQty": { "class" : "th-good-qty last-child", "label" : "Good Qty", key: 'goodQty', sortable: false}}, 
				{"pendingQty": { "class" : "th-pending-qty d-stack-none", "label" : "Pending Qty", key: 'pendingQty', sortable: false}}, 
				{"totalQty": { "class" : "th-total-qty d-stack-none", "label" : "Total Qty", key: 'totalQty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsWorkOrderExecutionNg: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number"}}, 
				{"ngCategory": { "class" : "th-ng-category", "label" : "Ng Category", key: 'ngCategory.name', sortable: false}}, 
				{"ngQty": { "class" : "th-ng-qty", "label" : "Ng Qty", key: 'ngQty', sortable: false}}, 
				// {"actions": { "class" : "th-actions", "label" : ""}}
			],
			fieldsWorkOrderExecutionHoldTime: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number"}}, 
				{"startTime": { "class" : "th-start-time", "label" : "Start Time", key: 'startTime', sortable: false}}, 
				{"endTime": { "class" : "th-end-time", "label" : "End Time", key: 'endTime', sortable: false}}, 
				//{"remark": { "class": "th-remark", "label": "Remark", key: "remark", sortable: false}}
				// {"actions": { "class" : "th-actions", "label" : ""}}
			],
			fieldsInputControlTime: [
				{"no": {"class": "th-number", "label": "No"}},
				{"controlTime": {"class" : "th-control-time", "label": "Name", key: "controlTime", sortable: false}},
			],
			workOrderNgTest: [
				{
					ngQty: 10,
					ngCategory: {
						name: 'testPineda',
					},
				},
			],
			fieldsWorkOrderExecutionControlTime: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"productionControlTime": { "class" : "th-production-control-time first-child", "label" : "Production Control Time", key: 'productionControlTime.standarTimeId', sortable: false}}, 
				{"startControlTime": { "class" : "th-start-control-time", "label" : "Start Control Time", key: 'startControlTime', sortable: false}}, 
				{"stopControlTime": { "class" : "th-stop-control-time last-child", "label" : "Stop Control Time", key: 'stopControlTime', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelWorkOrderExecutionNg1: {},
			modelWorkOrderExecutionNg2: {},
			modelWorkOrderExecutionHoldTime: {},
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			customer: {},
			line: {},
			isDownloadWorkOrderExecutionNg: false,
			modelWorkOrderExecutionDetail : {},
			isShowPopupWorkOrderExecutionDetail : false,
			isShowPopupUploadWorkOrderExecutionDetail : false,
			isShowPopupWorkOrderExecutionDetailScan : false,
			isShowPopupWorkOrderExecutionNg1 : false,
			isShowPopupWorkOrderExecutionNg2 : false,
			isShowPopupWorkOrderExecutionHoldTime: false,
			modelWorkOrderExecutionControlTime : {},
			isShowPopupWorkOrderExecutionControlTime : false,
			isShowPopupUploadWorkOrderExecutionControlTime : false,
			isShowPopupWorkOrderExecutionControlTimeScan : false,
			filterWorkOrderExecution : null,
			currentWorkOrderExecutionPage : 1,
			workOrderExecutionPageSize: 10,
			sortByWorkOrderExecution: '',
			sortDescWorkOrderExecution: '',
			filterWorkOrderExecutionDetail : null,
			currentWorkOrderExecutionDetailPage : 1,
			workOrderExecutionDetailPageSize: 10,
			sortByWorkOrderExecutionDetail: '',
			sortDescWorkOrderExecutionDetail: '',
			sortingByWorkOrderExecutionDetail: [],
			workOrderExecutionDetails : [],
			workOrderExecutionDetailId : '',
			workOrderExecutionNgs1 : [],
			workOrderExecutionNgs2 : [],
			workOrderExecutionHoldTimes: [],
			workOrderExecutionNgId : '',
			workOrderExecutionHoldTimeId: '',
			totalWorkOrderExecutionDetailRow : 0,
			isShowWorkOrderExecutionDetailFilter: false,
			isDownloadWorkOrderExecutionDetail: false,
			filterWorkOrderExecutionControlTime : null,
			currentWorkOrderExecutionControlTimePage : 1,
			workOrderExecutionControlTimePageSize: 10,
			sortByWorkOrderExecutionControlTime: '',
			sortDescWorkOrderExecutionControlTime: '',
			sortingByWorkOrderExecutionControlTime: [],
			workOrderExecutionControlTimes : [],
			workOrderExecutionControlTimeId : '',
			totalWorkOrderExecutionControlTimeRow : 0,
			isShowWorkOrderExecutionControlTimeFilter: false,
			isDownloadWorkOrderExecutionControlTime: false,
			workOrderProcessDetails: [],
			workOrderProcessDetail: null,
			parts: [],
			productionControlTimeDetails: [],
			shifts: [],
			isShiftComboLoading: false,
			billOfProcessDetails: [],
			isBillOfProcessDetailComboLoading: false,
			machines: [],
			isMachineComboLoading: false,
			userInfos: [],
			operators: [],
			isOperatorComboLoading: false,
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderProcessDetailComboLoading: false,
			isUserInfoComboLoading: false,
			isWorkOrderExecutionComboLoading: false,
			isPartComboLoading: false,
			isProductionControlTimeDetailComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			workOrderProcessDetailQrCode: '',
			isScanWorkOrderProcessDetailLoading: false,
			billOfProcessDetailQrCode: '',
			isScanBillOfProcessDetailLoading: false,
			machineQrCode: '',
			isScanMachineLoading: false,
			operatorQrCode: '',
			isScanOperatorLoading: false,
			elapsedTime: 0,
			formattedTime: "00:00:00",
			timer: null,
			controlTimes: [],
			sortByWorkOrderExecutionNg: '',
			sortDescWorkOrderExecutionNg: '',
			sortingByWorkOrderExecutionNg: [],
			sortByWorkOrderExecutionHoldTime: '',
			sortDescWorkOrderExecutionHoldTime: '',
			sortingByWorkOrderExecutionHoldTime: [],
			existingControlTime: [],
			isLastProcess : false,
			currentUser : '',
			isWopScanned: false,
			greeting: '',
			summaries: [],
			operatorFullName: '',
		}
	},
	methods : {
		formatDate(dateString) {
			const date = new Date(dateString);
			const options = {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				hour12: false,  // Use 24-hour time format
			};
			return date.toLocaleString('en-GB', options).replace(',', '');
		},
		userConfirmation: async function() {
			let message = 'Apakah Data sudah sesuai dan anda ingin melanjutkan proses?';
			if(!await this.showPopupWithMessage(message)) return;

			this.goToNext(this.scanPageIndex + 1, "scren 4");
		},
		getWorkOrderExecution : async function(id) {
			this.isBusy = true;
			await WorkOrderExecution.getData(this, id).then(result => {
				this.model = result;

				if(!this.operatorFullName) {
					if(result.operator != null) {
						this.operatorFullName = result.operator.firstName + " " + result.operator.lastName;
					}
				}

				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				if(this.model.workOrderProcessDetailId != null) {
					promises.push(
						this.getWorkOrderProcessDetail(this.model.workOrderProcessDetailId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				if(this.model.billOfProcessDetailId != null) {
					promises.push(
						this.getBillOfProcessDetail(this.model.billOfProcessDetailId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				if(this.model.machineId != null) {
					promises.push(
						this.getMachine(this.model.machineId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});

				// if(this.model.finishProduction) this.goToNext(9, "production is finished");
				// if(this.model.startProduction) this.goToNext(8, this.model.id);
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderExecution = true;
			this.filterWorkOrderExecution.id = this.modelId;
			WorkOrderExecution.downloadDataDetail(this, this.filterWorkOrderExecution).then(result => {
				this.isDownloadWorkOrderExecution = false;
			}).catch(error => { this.isDownloadWorkOrderExecution = false; })
		},
		getWorkOrderExecutionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionDetail);
			if (this.modelId == null) return;
			filter.workOrderExecutionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByWorkOrderExecutionDetail != null) {
				this.sortingByWorkOrderExecutionDetail[this.sortByWorkOrderExecutionDetail] = this.sortDescWorkOrderExecutionDetail;
			}
			let currentPage = (this.currentWorkOrderExecutionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionDetailPageSize = 0;
			// disable paging end
			WorkOrderExecutionDetail.getList(this, filter, this.sortingByWorkOrderExecutionDetail, currentPage , this.workOrderExecutionDetailPageSize).then(result => {
				this.currentWorkOrderExecutionDetailPage = currentPage + 1;
				this.workOrderExecutionDetails = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
					);
				this.workOrderExecutionDetailsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
					);
				this.totalWorkOrderExecutionDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderExecutionHoldTimes: async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionHoldTime);
			filter.workOrderExecutionId = this.model.id;
			// if(this.sortByWorkOrderExecutionHoldTime != null) {
			// 	this.sortingByWorkorderExecutionHoldTime[this.sortByWorkOrderExecutionHoldTime] = this.sortDescWorkOrderExecutionHoldTime;
			// }
			let currentPage = (this.currentWorkOrderExecutionHoldTimePage - 1);
			if(isAddRow) {
				let totalData = this.workOrderExecutionHoldTimes + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionHoldTimes);
				currentPage = page - 1;
			}
			//disable paging start
			currentPage = null;
			this.workOrderExecutionHoldTimePageSize = 0;
			//disable paging end;
			await WorkOrderExecutionHoldTime.getList(this, filter, null, currentPage, this.workOrderExecutionHoldTimePageSize).then(result => {
				this.currentWorkOrderExecutionHoldTimePage = currentPage + 1;
				this.workOrderExecutionHoldTimes = result.data
				console.log("result data", result.data);
			}).catch(error => {});
		},
		getWorkOrderExecutionNgs1 : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionNg);
			if(this.model.workOrderExecutionDetail.length == 0) return;
			filter.workOrderExecutionDetailId = this.model.workOrderExecutionDetail[0].id;
			filter.draftMode = "1";
			if (this.sortByWorkOrderExecutionNg != null) {
				this.sortingByWorkOrderExecutionNg[this.sortByWorkOrderExecutionNg] = this.sortDescWorkOrderExecutionNg;
			}
			let currentPage = (this.currentWorkOrderExecutionNgPage1 - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionNgRow1 + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionNgPageSize1);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionNgPageSize1 = 0;
			// disable paging end
			await WorkOrderExecutionNg.getList(this, filter, this.sortingByWorkOrderExecutionNg, currentPage , this.workOrderExecutionNgPageSize1).then(result => {
				this.currentWorkOrderExecutionNgPage1 = currentPage + 1;
				this.workOrderExecutionNgs1 = result.data;
			}).catch(error => {});
		},
		getWorkOrderExecutionNgs2 : async function(isAddRow) {
			if(this.model.workOrderExecutionDetail.length < 2) return;
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionNg);
			if (this.model.workOrderExecutionDetail[0].id == null) return;
			filter.workOrderExecutionDetailId = this.model.workOrderExecutionDetail[1].id;
			filter.draftMode = "1";
			if (this.sortByWorkOrderExecutionNg != null) {
				this.sortingByWorkOrderExecutionNg[this.sortByWorkOrderExecutionNg] = this.sortDescWorkOrderExecutionNg;
			}
			let currentPage = (this.currentWorkOrderExecutionNgPage2 - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionNgRow2 + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionNgPageSize2);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionNgPageSize2 = 0;
			// disable paging end
			await WorkOrderExecutionNg.getList(this, filter, this.sortingByWorkOrderExecutionNg, currentPage , this.workOrderExecutionNgPageSize2).then(result => {
				this.currentWorkOrderExecutionNgPage2 = currentPage + 1;
				this.workOrderExecutionNgs2 = result.data;
			}).catch(error => {});
		},
		getWorkOrderExecutionControlTimes : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionControlTime);
			if (this.modelId == null) return;
			filter.workOrderExecutionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByWorkOrderExecutionControlTime != null) {
				this.sortingByWorkOrderExecutionControlTime[this.sortByWorkOrderExecutionControlTime] = this.sortDescWorkOrderExecutionControlTime;
			}
			let currentPage = (this.currentWorkOrderExecutionControlTimePage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionControlTimeRow + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionControlTimePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionControlTimePageSize = 0;
			// disable paging end
			WorkOrderExecutionControlTime.getList(this, filter, this.sortingByWorkOrderExecutionControlTime, currentPage , this.workOrderExecutionControlTimePageSize).then(result => {
				this.currentWorkOrderExecutionControlTimePage = currentPage + 1;
				this.workOrderExecutionControlTimes = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
					);
				this.workOrderExecutionControlTimesFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
					);
				this.totalWorkOrderExecutionControlTimeRow = result.dataCount;
			}).catch(error => {});
		},
		getExistingControlTime: async function (draftMode) {
			let filter = {};
			if (this.modelId == null) return null; // Return null to indicate no data when modelId is null
			filter.workOrderExecutionId = this.model.id;
			filter.draftMode = draftMode;
			if (this.sortByWorkOrderExecutionControlTime != null) {
				this.sortingByWorkOrderExecutionControlTime[this.sortByWorkOrderExecutionControlTime] = this.sortDescWorkOrderExecutionControlTime;
			}
			let currentPage = (this.currentWorkOrderExecutionControlTimePage - 1);
			// disable paging start
			currentPage = null;
			this.workOrderExecutionControlTimePageSize = 0;
			// disable paging end
			try {
				const result = await WorkOrderExecutionControlTime.getList(
					this,
					filter,
					this.sortingByWorkOrderExecutionControlTime,
					currentPage,
					this.workOrderExecutionControlTimePageSize
				);
				if(draftMode == "0") {
					this.existingControlTime = result.data;
				} else if(draftMode == "2") {
					this.controlTimes = result.data;
				}
				return result.data;
			} catch (error) {
				return null; // Return null in case of an error
			}
		},
		getWorkOrderExecutions : async function(input) {
			let filter = new WorkOrderExecutionFilter();
			if (input != undefined) {
				filter.Shift = input;
			}
			this.isWorkOrderExecutionComboLoading = true;
			await WorkOrderExecution.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
				}
				this.isWorkOrderExecutionComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isWorkOrderProcessDetailComboLoading = true;
			await WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
				this.isWorkOrderProcessDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getProductionControlTimeDetails : async function(input) {
			let filter = new ProductionControlTimeDetailFilter();
			if (input != undefined) {
				filter.standarTimeId = input;
			}
			this.isProductionControlTimeDetailComboLoading = true;
			await ProductionControlTimeDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionControlTimeDetails = result.data
				}
				this.isProductionControlTimeDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getShifts : async function(input) {
			let filter = new ShiftFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await Shift.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.shifts = result.data

					this.shifts.sort((a, b) => a.sequence - b.sequence);
				}
			})
			.catch(error => {});
		},
		setSelectedShift(item) {
			if(item == undefined || item == null) {
				this.model.shiftId = null;
				this.model.shift = null;
			} else {
				this.model.shiftId = item.id;
				this.model.shift = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getBillOfProcessDetails : async function(input) {
			let filter = new BillOfProcessDetailFilter();
			if (input != undefined) {
				filter.sequence = input;
			}
			await BillOfProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedBillOfProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.billOfProcessDetailId = null;
				this.model.billOfProcessDetail = null;
			} else {
				this.model.billOfProcessDetailId = item.id;
				this.model.billOfProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedMachine(item) {
			if(item == undefined || item == null) {
				this.model.machineId = null;
				this.model.machine = null;
			} else {
				this.model.machineId = item.id;
				this.model.machine = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			await UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedOperator(item) {
			if(item == undefined || item == null) {
				this.model.operatorUserName = null;
				this.model.operator = null;
			} else {
				this.model.operatorUserName = item.userName;
				this.model.operator = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcessDetail : async function(id) {
			await WorkOrderProcessDetail.getData(this, id).then(result => {
				this.model.workOrderProcessDetail = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		getBillOfProcessDetail : async function(id) {
			BillOfProcessDetail.getData(this, id).then(result => {
				this.model.billOfProcessDetail = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		getMachine : async function(id) {
			Machine.getData(this, id).then(result => {
				this.model.machine = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		async getCustomer(id) {
			try {
				this.isBusy = true;
				const result = await Customer.getData(this, id);
				this.customer = result;
				return result;
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			} finally {
				this.isBusy = false;
			}
		},
		async getLine(id) {
			try {
				this.isBusy = true;
				const result = await Line.getData(this, id);
				this.line = result;
				return result;
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			} finally {
				this.isBusy = false;
			}
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.workOrderExecutionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			this.resetModal();
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return WorkOrderExecution.updateData(this, model, id)
					.catch((error) => {
						return this.getWorkOrderExecution(id);
					});
				}
				return false;
			});
		},
		updateDataWorkOrderDetail: async function(obj, id) {
			let promises = Array();

			return Promise.all(promises).then(async (results) => {
				if (id != '' && id != null && id != undefined) {
					await WorkOrderExecutionDetail.updateData(this, obj, id)
					await this.getSummaryQty(this.model.id)
					.catch(async (error) => {
						return await this.getWorkOrderExecution(id);
					});
				}
				return false;
			});
		},
		updateStartTime: async function(newValue, obj) {
			obj.startTime = newValue;
			await this.updateDataHoldTime(obj, obj.id);
		},
		updateEndTime: async function(newValue, obj) {
			obj.endTime = newValue;
			await this.updateDataHoldTime(obj, obj.id);
		},
		updateDataHoldTime: async function(obj, id) {
			let promises = Array();

			return Promise.all(promises).then(async (results) => {
				if(id != '' && id != null && id != undefined) {
					await WorkOrderExecutionHoldTime.updateData(this, obj, id);
					await this.getWorkOrderExecutionHoldTimes()
					.catch(async (error) => {
						
					})
				}
			});
		},
		updateDataWorkOrderNg: async function(obj, id) {
			let promises = Array();

			return Promise.all(promises).then(async (results) => {
				if (id != '' && id != null && id != undefined) {
					await WorkOrderExecutionNg.updateData(this, obj, id)
					await this.getSummaryQty(this.model.id)
					.catch(async (error) => {
						return await this.getWorkOrderExecution(this.model.id);
					});
				}
				return false;
			});
		},
		updateDataControlTime(id, obj) {
			let promises = Array();

			if(!obj.duration) return; 
			let value = Number(obj.duration);
			if(Number.isNaN(value)) {
				obj.duration = null;
				this.toast({ message: 'Data yang di input bukan berupa angka', title: 'Error!', variant: 'danger' });
				return;
			}

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return WorkOrderExecutionControlTime.updateData(this, obj, id)
					.catch((error) => {
						return this.getWorkOrderExecution(id);
					});
				}
				return false;
			});
		},
		calculateControlTime(duration, startControlTime) {
			if(!duration) return null;
			// Step 1: Remove the timezone information and replace space with 'T' to standardize the format
			let standardizedTime = startControlTime.split('+')[0].replace(" ", "T");

			// Convert the standardized time string to a Date object
			let dateTime = new Date(standardizedTime);
			
			// Step 2: Add the duration (in minutes) to the start time
			dateTime.setMinutes(dateTime.getMinutes() + duration);

			// Step 3: Format the result as a local time string (YYYY-MM-DD HH:mm)
			const year = dateTime.getFullYear();
			const month = String(dateTime.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
			const day = String(dateTime.getDate()).padStart(2, '0');
			const hours = String(dateTime.getHours()).padStart(2, '0');
			const minutes = String(dateTime.getMinutes()).padStart(2, '0');

			// Step 4: Construct the formatted date-time string
			let result = `${year}-${month}-${day} ${hours}:${minutes}`;

			console.log("startTime", startControlTime);
			console.log("result calculate", result);

			return result;
		},
		onHidden() {
			this.getWorkOrderExecutions();
		},
		addRowDataWorkOrderExecutionHoldTime(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					WorkOrderExecutionHoldTime.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderExecutionHoldTimes(true);
						this.isShowPopupWorkOrderExecutionHoldTime = false;
						this.resetModal();
					})
				} else {
					WorkOrderExecutionHoldTime.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderExecutionHoldTimes(true);
						this.isShowPopupWorkOrderExecutionHoldTime = false;
						this.resetModal();
					})
				}
			}
		},
		addRowDataWorkOrderExecutionNg(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					WorkOrderExecutionNg.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderExecutionNgs1(true);
						this.getWorkOrderExecutionNgs2(true);
						this.isShowPopupWorkOrderExecutionNg1 = false;
						this.isShowPopupWorkOrderExecutionNg2 = false;
					})
				} else {
					WorkOrderExecutionNg.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderExecutionNgs1(true);
						this.getWorkOrderExecutionNgs2(true);
						this.isShowPopupWorkOrderExecutionNg1 = false;
						this.isShowPopupWorkOrderExecutionNg2 = false;
					})
				}
			}
		},
		addRowDataWorkOrderExecutionDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderExecutionDetails(true);
						this.isShowPopupWorkOrderExecutionDetail = false;
					})
				} else {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionDetail.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderExecutionDetails(true);
						this.isShowPopupWorkOrderExecutionDetail = false;
					})
				}
			}
		},
		async editRowDataWorkOrderExecutionDetail(id) {
			this.workOrderExecutionDetailId = id;
			this.isShowPopupWorkOrderExecutionDetail = true; 
		},
		async deleteRowDataWorkOrderExecutionDetail(id) {
			WorkOrderExecutionDetail.deleteData(this, id).then(result => { this.getWorkOrderExecutionDetails(); });
		},
		async resetDataWorkOrderExecutionDetail() {
			this.workOrderExecutionDetailId = "";
			this.isShowPopupWorkOrderExecutionDetail = true;
		},
		async addDataWorkOrderExecutionDetail() {
			WorkOrderExecutionDetail.createData(this, { workOrderExecutionId: this.modelId })
			.then(result => {
				this.getWorkOrderExecutionDetails(true);
			})
		},
		async addFromClipboardWorkOrderExecutionDetail() {
			let workOrderProcessDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderProcessDetails.push({ workOrderProcessDetail: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionDetail.addFromClipboard(this, workOrderProcessDetails).then(result => { this.getWorkOrderExecutionDetails() });
			});
		},
		async replaceFromClipboardWorkOrderExecutionDetail() {
			let workOrderProcessDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderProcessDetails.push({ workOrderProcessDetail: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionDetail.replaceFromClipboard(this, workOrderProcessDetails).then(result => { this.getWorkOrderExecutionDetails() });
			});   
		},
		showPopupUploadWorkOrderExecutionDetail() {
			this.isShowPopupUploadWorkOrderExecutionDetail = true;
		},
		uploadDataWorkOrderExecutionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderExecutionDetail = false; 
		},
		downloadWorkOrderExecutionDetail(modalEvent) {
			this.isDownloadWorkOrderExecutionDetail = true;
			this.filterWorkOrderExecutionDetail.workOrderExecutionId = this.modelId;
			WorkOrderExecutionDetail.downloadDataDetail(this, this.filterWorkOrderExecutionDetail).then(result => {
				this.isDownloadWorkOrderExecutionDetail = false;
			}).catch(error => { this.isDownloadWorkOrderExecutionDetail = false; })
		},
		saveInputWorkOrderExecutionDetail(item) {
			if (this.workOrderExecutions != null && this.workOrderExecutions != undefined  && this.workOrderExecutions.length > 0) {
				item.workOrderExecution = this.workOrderExecutions.find(q => q.id == item.workOrderExecutionId);
			}
			if (this.workOrderProcessDetails != null && this.workOrderProcessDetails != undefined  && this.workOrderProcessDetails.length > 0) {
				item.workOrderProcessDetail = this.workOrderProcessDetails.find(q => q.id == item.workOrderProcessDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderExecutionDetail.updateData(this, item, item.id);
				}
			});
		},
		addRowDataWorkOrderExecutionControlTime(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionControlTime.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderExecutionControlTimes(true);
						this.isShowPopupWorkOrderExecutionControlTime = false;
					})
				} else {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionControlTime.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderExecutionControlTimes(true);
						this.isShowPopupWorkOrderExecutionControlTime = false;
					})
				}
			}
		},
		async editRowDataWorkOrderExecutionControlTime(id) {
			this.workOrderExecutionControlTimeId = id;
			this.isShowPopupWorkOrderExecutionControlTime = true; 
		},
		async deleteRowDataWorkOrderExecutionControlTime(id) {
			WorkOrderExecutionControlTime.deleteData(this, id).then(result => { this.getWorkOrderExecutionControlTimes(); });
		},
		async resetDataWorkOrderExecutionControlTime() {
			this.workOrderExecutionControlTimeId = "";
			this.isShowPopupWorkOrderExecutionControlTime = true;
		},
		async addDataWorkOrderExecutionControlTime() {
			WorkOrderExecutionControlTime.createData(this, { workOrderExecutionId: this.modelId })
			.then(result => {
				this.getWorkOrderExecutionControlTimes(true);
			})
		},
		async addFromClipboardWorkOrderExecutionControlTime() {
			let productionControlTimes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					productionControlTimes.push({ productionControlTime: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionControlTime.addFromClipboard(this, productionControlTimes).then(result => { this.getWorkOrderExecutionControlTimes() });
			});
		},
		async replaceFromClipboardWorkOrderExecutionControlTime() {
			let productionControlTimes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					productionControlTimes.push({ productionControlTime: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionControlTime.replaceFromClipboard(this, productionControlTimes).then(result => { this.getWorkOrderExecutionControlTimes() });
			});   
		},
		showPopupUploadWorkOrderExecutionControlTime() {
			this.isShowPopupUploadWorkOrderExecutionControlTime = true;
		},
		uploadDataWorkOrderExecutionControlTime(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderExecutionControlTime = false; 
		},
		downloadWorkOrderExecutionControlTime(modalEvent) {
			this.isDownloadWorkOrderExecutionControlTime = true;
			this.filterWorkOrderExecutionControlTime.workOrderExecutionId = this.modelId;
			WorkOrderExecutionControlTime.downloadDataDetail(this, this.filterWorkOrderExecutionControlTime).then(result => {
				this.isDownloadWorkOrderExecutionControlTime = false;
			}).catch(error => { this.isDownloadWorkOrderExecutionControlTime = false; })
		},
		saveInputWorkOrderExecutionControlTime(item) {
			if (this.productionControlTimeDetails != null && this.productionControlTimeDetails != undefined  && this.productionControlTimeDetails.length > 0) {
				item.productionControlTime = this.productionControlTimeDetails.find(q => q.id == item.productionControlTimeId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderExecutionControlTime.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupWorkOrderExecutionHoldTime = false;
			this.isShowPopupWorkOrderExecutionNg1 = false;
			this.isShowPopupWorkOrderExecutionNg2 = false;
			this.isShowPopupUploadWorkOrderExecutionDetail = false; 
			this.isShowPopupWorkOrderExecutionDetail = false; 
			if (modalType == 'WorkOrderExecutionDetail') {
				this.getWorkOrderExecutionDetails();
			}
			this.isShowPopupUploadWorkOrderExecutionControlTime = false; 
			this.isShowPopupWorkOrderExecutionControlTime = false; 
			if (modalType == 'WorkOrderExecutionControlTime') {
				this.getWorkOrderExecutionControlTimes();
			}
			this.workOrderProcessDetailQrCode = '';
			this.billOfProcessDetailQrCode = '';
			this.machineQrCode = '';
			this.operatorQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
			this.modelWorkOrderExecutionNg1= {};
			this.modelWorkOrderExecutionNg2= {};
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			// if (this.windowWidth <= 768 ) {
			// }
		},
		scanWorkOrderProcessDetail: async function() {
			try {
				let qrCode = encodeURIComponent(this.workOrderProcessDetailQrCode);
				let id = this.model.id;

				let response = await this.$http.get(`WorkOrderExecution/ScanWorkOrderProcessDetail?id=${id}&qrcode=${qrCode}`);

				if (response && response.data && response.data.data.length > 0) {
					this.isWopScanned = true;
					this.toast({ message: 'Success reading Work Order Process Number', title: 'Scan Success', variant: 'success' });
					let result = response.data.data;
					this.model.workOrderProcessDetailId = result[0].id;
					this.model.qtyPlan = result[0].qtyPlan;
					await this.updateData();
					this.$nextTick(() => {
						this.focusInput(this, "fieldset-bill-of-process-detail");
					});
				} else {
					this.toast({ message: 'Work Order Process Number not found!', title: 'Error', variant: 'danger' });
					this.workOrderProcessDetailQrCode = '';
				}
			} catch (error) {
				this.workOrderProcessDetailQrCode = '';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-work-order-process-detail");
				});
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				//this.$store.dispatch('addErrorMessageGlobal', error);
				//throw error;
			}
		},
		getSummaryQty : async function() {
			try {
				const response = await this.$http.get(`WorkOrderExecution/getsummaryqty/${this.model.id}`)
				if(response && response.data) {
					this.summaries = response.data;
				} 
			} catch(error) {
				let errors = error.response.data.errors['1']
				this.toas({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000});
			}
		},
		getGreetingMessage : async function() {
			try {
				const response = await this.$http.get('WorkOrderExecution/getgreetingmessage');
				if(response && response.data) {
					this.greeting = response.data;
				}
			} catch (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		scanBillOfProcessDetail: async function() {
			try {
				let qrCode = encodeURIComponent(this.billOfProcessDetailQrCode);
				let id = this.model.id;
				let shiftId = this.model.shiftId;
				let wopdId = this.model.workOrderProcessDetailId != null ? this.model.workOrderProcessDetailId : 0;

				let response = await this.$http.get(`WorkOrderExecution/ScanBillOfProcessDetail?id=${id}&qrcode=${qrCode}&wopdid=${wopdId}&shiftid=${shiftId}`);
				
				if (response && response.data && response.data.data.length > 0) {
					this.billOfProcessDetailQrCode = '';
					this.workOrderProcessDetailQrCode = '';
					let result = response.data.data;
					//this.model.billOfProcessDetailId = result[0].id;
					if(result[0].dataExist == true) {
						let id = result[0].id;
						
						if(this.$route.path == '/workorderexecution/scan/' + id) {
							await this.getWorkOrderExecution(id);
							//this.goToNext(8, id);
							return;
						}
						this.$router.replace('/workorderexecution/scan/' + id, async () => {
							await this.getWorkOrderExecution(id);
							//this.goToNext(8, id);
							return;
						});
					} else {
						this.model.billOfProcessDetailId = result[0].id;
						await this.updateData();
						await this.getWorkOrderExecution(id);
						this.goToNext(3, "screen 3");
					}
				} else {
					this.toast({ message: 'Work Order Sub Process not found!', title: 'Error', variant: 'danger' });
				}
			} catch (error) {
				this.billOfProcessDetailQrCode = '';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-bill-of-process-detail");
				});
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				//this.$store.dispatch('addErrorMessageGlobal', error);
				//throw error;
			}
		},
		async scanMachine() {
			try {
				let qrCode = encodeURIComponent(this.machineQrCode);
				let id = this.model.id;
				let bopdId = this.model.billOfProcessDetailId;

				let response = await this.$http.get(`WorkOrderExecution/ScanMachine?id=${id}&qrcode=${qrCode}&bopdid=${bopdId}`);
				
				if (response && response.data && response.data.data.length > 0) {
					this.machineQrCode = '';
					let result = response.data.data;
					this.model.machineId = result[0].id;
					await this.updateData();
					await this.getWorkOrderExecution(this.model.id);
					await this.goToNext(5, "screen 5");
					} else {
					this.toast({ message: 'Machine not found!', title: 'Error', variant: 'danger' });
				}
			} catch (error) {
				this.machineQrCode = '';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-machine");
				});
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				//('addErrorMessageGlobal', error);
				//throw error;
			}
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		async scanOperator() {
			try {
				// let message = 'Apakah Data sudah sesuai dan anda ingin melanjutkan proses?';
				// if(!await this.showPopupWithMessage(message)) return;

				let qrCode = encodeURIComponent(this.operatorQrCode);
				let id = this.model.id;

				let response = await this.$http.get(`WorkOrderExecution/ScanOperator?id=${id}&qrcode=${qrCode}`);
				this.operatorQrCode = '';
				if (response && response.data && response.data.data.length > 0) {
					let result = response.data.data;
					this.model.operatorUserName = result[0].userName;
					this.operatorFullName = result[0].firstName + " " + result[0].lastName;
					this.updateData();
					await this.goToNext(6, "screen 6");
				} else {
					this.toast({ message: 'Operator not found!', title: 'Error', variant: 'danger' });
				}
			} catch (error) {
				this.operatorQrCode = '';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-operator");
				});
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				//this.$store.dispatch('addErrorMessageGlobal', error);
				//throw error;
			}
		},
		async startProduction() {
			let data = await WorkOrderExecution.startProduction(this, this.model.id);
			await this.getWorkOrderExecution(this.model.id);
			await this.goToNext(8, data.id);
		},

		async finishProduction() {
			let message = `Apakah Anda yakin ingin menyelesaikan produksi atas Work Order Process ${this.model.workOrderProcessDetail.lotNo}?`;
			if(!await this.showPopupWithMessage(message)) return;

			let data = await WorkOrderExecution.finishProduction(this, this.model.id);
			this.model = data;
			await this.goToNext(9, data.id);
		},
		async productionResult() {

			let partNames = [];

			this.model.workOrderExecutionDetail.forEach(item => {
				if(item.goodQty <= 0) {
					partNames.push(item.part.partNumber);
				}
			});

			if(partNames.length > 0) {
				let message = '';
				partNames.forEach(e => {
					message += `Part ${e} tidak memiliki Good Qty<br>`
				});

				message += "<br>Apakah Anda yakin ingin melanjutkan?";

				if(!await this.showPopupWithMessage(message)) return;
			}

			let data = await WorkOrderExecution.productionResult(this, this.model.id);
			if(data) {
				await this.goToNext(11, data.id);
			}
		},
		async checkLastProcess(id) {
			let data = await WorkOrderExecution.checkLastProcess(this, id);
			if(data > 0) {
				this.isLastProcess = true
			}
		},
		async productionControlSetting() {
			try {
				// Check if any Time Execution is not filled
				const unfilledTimeExecution = this.controlTimes.find(controlTime =>
					controlTime.startControlTime == null || controlTime.stopControlTime == null
				);

				// If any Time Execution is not filled, show a confirmation popup
				if (unfilledTimeExecution) {
					let message = 'Masih terdapat Time Execution yang belum diisi. Apakah anda yakin ingin melanjutkan ke proses selanjutnya?';
					if (!await this.showPopupWithMessage(message)) return;
				}

				let data = await WorkOrderExecutionControlTime.productionControlSetting(this, this.model.id);
				if(!data) {
					await this.goToNext(this.scanPageIndex - 1, "current screen");
				}
				
				await this.getSummaryQty(this.model.id)

				return data;
			} catch(error) {
				await this.goToNext(this.scanPageIndex - 1, "current screen");
			}
		},

		async goToNext(page, item) {

			if(page == 2) {
				this.scanPageIndex = page;
				this.model.shiftId = item;
				this.updateData();
				return;
			}
			if(page == 3) {
				this.scanPageIndex = page;
				let wopdId = this.model.workOrderProcessDetailId;
				await this.getWorkOrderProcessDetail(wopdId);

				if(this.model.workOrderProcessDetail != null && this.model.workOrderProcessDetail.part != null) {
					let customerId = this.model.workOrderProcessDetail.part.customerId;
					await this.getCustomer(customerId)
				}
				if(this.model.workOrderProcessDetail != null && this.model.workOrderProcessDetail.workOrderProcess != null) {
					let lineCodeId = this.model.workOrderProcessDetail.workOrderProcess.lineCodeId;
					await this.getLine(lineCodeId)
				}

				this.updateData();
			}
			if(page == 4) {
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-machine");
				});
				this.scanPageIndex = page;
				return;
			}
			if(page == 5) {
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-operator");
				});
				this.scanPageIndex = page;
				this.updateData();
				return;
			}
			if(page == 6) {
				this.scanPageIndex = page;
				this.updateData();
				//this.getWorkOrderExecution(this.model.id);
				return;
			}
			if(page == 7) {
				this.scanPageIndex = page;
				return;
			}
			if(page == 8) {
				this.scanPageIndex = page;
				//await this.getWorkOrderExecution(item);
				
				await this.getExistingControlTime("0");
				if(this.existingControlTime.length != 0) {
					this.goToNext(10, "screen 10");
					return;
				}

				if(this.model.finishProduction) {
					this.goToNext(9, "screen 9");
					return;
				}

				return;
			}

			if(page == 9) {
				this.scanPageIndex = page;
				await this.getWorkOrderExecutionHoldTimes();
				await this.getExistingControlTime("2");
				return;
			}

			if(page == 10) {
				let result = await this.productionControlSetting()
				// if(!await this.productionControlSetting()) {
				// 	this.goToNext(page - 1, "back");
				// }
				await this.getWorkOrderExecutionNgs1();
				await this.getWorkOrderExecutionNgs2();
				await this.checkLastProcess(this.model.billOfProcessDetailId);
				//this.scanPageIndex = page;
				if(result) {
					this.scanPageIndex = page;
				}
				return;
			}

			if(page == 11) {
				this.scanPageIndex = page;
			}
		},
		goToPrev(page) {
			this.scanPageIndex = page;
			if(page == 1) {
				this.model.shiftId = null;
				this.workOrderProcessDetailQrCode = '';
				this.billOfProcessDetailQrCode = '';
				this.isWopScanned = false;
				//this.scanPageIndex = 1;
				this.updateData();
				return;
			}
			// if(page == 2) {
			// 	this.scanPageIndex = 2;
			// }
		},
		startTimer() {
			// Update the timer every second
			this.timer = setInterval(this.updateTimer, 1000);
		},
		updateTimer() {
			if(this.model.startProduction == null || this.model.startProduction == undefined) return;
			const startTime = new Date(this.model.startProduction);
			const currentTime = new Date();
			const diff = Math.floor((currentTime - startTime) / 1000); // Time difference in seconds

			const hours = Math.floor(diff / 3600);
			const minutes = Math.floor((diff % 3600) / 60);
			const seconds = diff % 60;

			// Format with leading zeros
			const formattedHours = String(hours).padStart(2, '0');
			const formattedMinutes = String(minutes).padStart(2, '0');
			const formattedSeconds = String(seconds).padStart(2, '0');

			this.elapsedTime = diff;
			this.formattedTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		},
		async deleteRowDataWorkOrderExecutionHoldTime(id) {
			WorkOrderExecutionHoldTime.deleteData(this, id).then(result => { this.getWorkOrderExecutionHoldTimes(); });
		},
		async deleteRowDataWorkOrderExecutionNg1(id) {
			WorkOrderExecutionNg.deleteData(this, id).then(result => { this.getWorkOrderExecutionNgs1(); });
		},
		async deleteRowDataWorkOrderExecutionNg2(id) {
			WorkOrderExecutionNg.deleteData(this, id).then(result => { this.getWorkOrderExecutionNgs2(); });
		},
		async addDataWorkOrderExecutionHoldTime() {
			this.isShowPopupWorkOrderExecutionHoldTime = true;
		},
		async addDataWorkOrderExecutionNg1() {
			this.isShowPopupWorkOrderExecutionNg1 = true;
		},
		async addDataWorkOrderExecutionNg2() {
			this.isShowPopupWorkOrderExecutionNg2 = true;
		},

		checkLogin: async function() {
			this.isLoading = true;
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `UserInfo/Me`).then(result => {
				if(!result.data) return;
				this.currentUser = result.data.firstName;
			}).catch(function(error) {
				this_.isLoading = false;
			});
		},
	},
	async beforeMount() {
		this.filterWorkOrderExecution = new WorkOrderExecutionFilter();
		this.filterWorkOrderExecutionDetail = new WorkOrderExecutionDetailFilter();
		this.filterWorkOrderExecutionNg = new WorkOrderExecutionNgFilter();
		this.filterWorkOrderExecutionControlTime = new WorkOrderExecutionControlTimeFilter();
		//this.getWorkOrderExecutions();
		//this.getWorkOrderProcessDetails();
		//this.getParts();
		//this.getProductionControlTimeDetails();
		await this.getShifts();
		//this.getBillOfProcessDetails();
		//this.getMachines();
		//this.getUserInfos();
		//this.getDocumentStatuss();
		await this.checkLogin();

	},
	async mounted() {

		let id = this.$route.params.id;
		await this.getGreetingMessage();
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			await this.getWorkOrderExecution(id);
		}

		this.$nextTick(() => {

			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});

		if (this.model.startProduction) {
			this.startTimer();
		} else {
			this.$watch("model.startProduction", (newValue, oldValue) => {
			if (newValue) {
				this.startTimer();
			}
			});
		}

		this.$root.$on('navigateToScanScreen', (step, screen) => {
			this.goToNext(8, screen);
		});
	},
	beforeDestroy() {
		// Clear the timer when the component is destroyed
		clearInterval(this.timer);
	},
	computed: {
		// operatorFullName() {
		// 	if(!this.model) return '';
		// 	return this.model.operator != null ? this.model.operator.firstName + ' ' + this.model.operator.lastName : '';
		// },
		groupedControlTimes() {
			return this.controlTimes.reduce((groups, controlTime) => {
				const standardTimeCategory = controlTime.productionControlTime?.standarTimeId?.standarTimeCategory;
				// Check if the standardTimeCategory is defined
				if (standardTimeCategory) {
					// If the group for this standardTimeCategory doesn't exist, create it
					if (!groups[standardTimeCategory.code]) {
						groups[standardTimeCategory.code] = [];
					}

					// Add the controlTime to the group
					groups[standardTimeCategory.code].push(controlTime);
				}

				return groups;
			}, {});
		}
	},
	watch : {
		model : {
			handler: function (newModel, oldModel) {
				if( (newModel.startProduction != null && newModel.startProduction != undefined)) {
					this.goToNext(8, newModel.id);
				}
			}
		},
		sortByWorkOrderExecutionNg : {
			handler: function() {
				this.getWorkOrderExecutionNgs1();
				this.getWorkOrderExecutionNgs2();
			}
		},
		sortDescWorkOrderExecutionNg: {
			handler: function() {
				this.getWorkOrderExecutionNgs1();
				this.getWorkOrderExecutionNgs2();
			}
		},
		currentWorkOrderExecutionNgPage1: {
			handler: function() {
				this.getWorkOrderExecutionNgs1();
			}
		},
		currentWorkOrderExecutionNgPage2: {
			handler: function() {
				this.getWorkOrderExecutionNgs2();
			}
		},
		workOrderExecutionNgPageSize1 : {
			handler: function() {
				this.getWorkOrderExecutionNgs1();
			}
		},
		workOrderExecutionNgPageSize2 : {
			handler: function() {
				this.getWorkOrderExecutionNgs2();
			}
		},
		filterWorkOrderExecutionNg: {
			handler: function() {
				this.getWorkOrderExecutionNgs1();
				this.getWorkOrderExecutionNgs2();
			},
			deep: true,
		},
		scanPageIndex() {
			this.hideToast();
		},
	},
}
</script>
